/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { AbstractCommand } from '../AbstractCommand';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { OasDocument } from '../../openapi/models/OasDocument';
import { OasPathItem } from '../../openapi/models/OasPathItem';

/**
 * A command used to create a new path item in a document.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class NewPathCommand extends AbstractCommand {
    public _newPath : string;

    public _pathExisted : boolean;

    public _nullPaths : boolean;

    public constructor(newPath? : any) {
        if(((typeof newPath === 'string') || newPath === null)) {
            let __args = arguments;
            super();
            if(this._newPath===undefined) this._newPath = null;
            if(this._pathExisted===undefined) this._pathExisted = false;
            if(this._nullPaths===undefined) this._nullPaths = false;
            if(this._newPath===undefined) this._newPath = null;
            if(this._pathExisted===undefined) this._pathExisted = false;
            if(this._nullPaths===undefined) this._nullPaths = false;
            (() => {
                this._newPath = newPath;
            })();
        } else if(newPath === undefined) {
            let __args = arguments;
            super();
            if(this._newPath===undefined) this._newPath = null;
            if(this._pathExisted===undefined) this._pathExisted = false;
            if(this._nullPaths===undefined) this._nullPaths = false;
            if(this._newPath===undefined) this._newPath = null;
            if(this._pathExisted===undefined) this._pathExisted = false;
            if(this._nullPaths===undefined) this._nullPaths = false;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[NewPathCommand] Executing.");
        let odoc : OasDocument = <OasDocument>document;
        if(this.isNullOrUndefined(odoc.paths)) {
            odoc.paths = odoc.createPaths();
            this._nullPaths = true;
        }
        if(this.isNullOrUndefined(odoc.paths.getPathItem(this._newPath))) {
            let pathItem : OasPathItem = odoc.paths.createPathItem(this._newPath);
            odoc.paths.addPathItem(this._newPath, pathItem);
            this._pathExisted = false;
        } else {
            this._pathExisted = true;
        }
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[NewPathCommand] Reverting.");
        let odoc : OasDocument = <OasDocument>document;
        if(this._pathExisted) {
            LoggerCompat.info("[NewPathCommand] path already existed, nothing done so no rollback necessary.");
            return;
        }
        if(this._nullPaths) {
            LoggerCompat.info("[NewPathCommand] Paths was null, deleting it.");
            odoc.paths = null;
        } else {
            LoggerCompat.info("[NewPathCommand] Removing a path item: %s", this._newPath);
            odoc.paths.removePathItem(this._newPath);
        }
    }
}
NewPathCommand["__class"] = "io.apicurio.datamodels.cmd.commands.NewPathCommand";
NewPathCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




